import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { IScholars } from 'types';
import { IRootState } from 'store';
import _ from 'lodash';
import DefaultAvatar from 'style/imgs/map/avatar.jpg';
import DefaultAvatar2 from 'style/imgs/map/avatar2.jpg';
import { setActiveScholar } from 'actions/users';
import styles from './index.module.scss';

interface IScholarListProps {
  activeScholarId: number | undefined;
  units: IScholars[] | null;
}

const mapStateToProps = (state: IRootState) => ({
  units: state.scholars.units,
  activeScholarId: state.users.userData?.activeScholarId,
});

const allowedRoutes = ['/map', '/digital-map'];

const ScholarList: React.FC<IScholarListProps> = ({
  units,
  activeScholarId,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const isAllowed = allowedRoutes.includes(location.pathname);

  const handleSetActiveKid = useCallback(
    (id: number) => {
      dispatch(setActiveScholar(id));
    },
    [dispatch]
  );

  if (!units || !isAllowed) {
    return null;
  }

  if (!units || units.length === 0) {
    return null;
  }

  return (
    <ul className={styles.scholarList}>
      {_.take(units, 5).map((s, i) => (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <li
          onClick={() => handleSetActiveKid(s.id)}
          onKeyDown={() => null}
          key={s.id}
        >
          {i === 0 ? (
            <div
              className={
                activeScholarId && s.id === activeScholarId ? styles.active : ''
              }
            >
              <div
                style={{
                  backgroundImage: `url(${s.avatar || DefaultAvatar})`,
                }}
              />
            </div>
          ) : (
            <div
              className={
                activeScholarId && s.id === activeScholarId ? styles.active : ''
              }
            >
              <div
                style={{
                  backgroundImage: `url(${s.avatar || DefaultAvatar2})`,
                }}
              />
            </div>
          )}
          <span className={styles.userName} title={s.name}>
            {s.name}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default connect(mapStateToProps)(ScholarList);
